export default __webpack_public_path__ + "static/media/expand-more-white.e60513b4.svg";